import script from "./WinesMap.vue?vue&type=script&setup=true&lang=js"
export * from "./WinesMap.vue?vue&type=script&setup=true&lang=js"

import "./WinesMap.vue?vue&type=style&index=0&id=70fa2d02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fa2d02"]])

export default __exports__